import { FC } from 'react';
import { Oferta } from 'src/shared/ui';
import { LoginForm } from 'src/widgets/LoginForm';

export const LoginPage: FC = () => {
  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex h-full w-full items-center justify-center">
        <LoginForm />
      </div>
      <Oferta classNames="mt-auto px-5 pb-2" />
    </div>
  );
};
